import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  // justify-content: space-between;
  flex-direction: column;

  background-color: #f4f4f4;
  border-radius: 8px;
  min-height: 400px;
`;
